<script setup lang="ts">
    import { computed } from 'vue';
    import { ROUTES } from '@/router';
    import { usePlanOrderDisplay } from '@/views/plan/usePlanOrderDisplay';
    import { useSurgicalGuideOrderDialog } from '@/views/plan/useSurgicalGuideOrderDialog';

    export interface Props {
        caseId: number;
        planId: number;
    }

    const props = defineProps<Props>();

    const { showOrderGuide, hasOrder, orderStatus, orderInfoPill } = usePlanOrderDisplay();
    const dialog = useSurgicalGuideOrderDialog();

    const pill = computed(() => orderInfoPill(props.planId));
</script>
<template>
    <div v-if="showOrderGuide" class="order-guide">
        <app-button
            v-if="!hasOrder(props.planId)"
            class="mt-2"
            color="green"
            data-testid="order-psi-guide-button"
            @click="dialog.openOrder(props.caseId, props.planId)"
        >
            Order PSI Guide
        </app-button>
        <app-button
            v-if="hasOrder(props.planId)"
            class="mt-2 guide-ordered"
            prepend-icon="mdi-check"
            color="green"
            disabled
        >
            {{ orderStatus(props.planId) }}
        </app-button>
        <v-alert
            v-if="pill"
            class="rounded-pill mt-3 order-info"
            :class="pill"
            :border="false"
        >
            <p v-if="pill === 'enter-cr'">
                Add CR Number to complete guide order
                <router-link :to="{ name: ROUTES.EDIT_CASE, params: { id: props.caseId } }">
                    here
                </router-link>
            </p>
            <p v-else-if="pill === 'requested'">
                Your ZB Sales Representative has been notified
            </p>
            <p v-else>Guide Successfully Ordered</p>
        </v-alert>
        <span class="powered-by-ossis">
            Powered By
            <span>
                <img alt="Ossis Logo" src="@/assets/images/ossis-logo.svg" />
            </span>
        </span>
    </div>
</template>

<style lang="scss">
    .order-guide {
        display: grid;
        text-align: center;
        font-size: 14px;
    }

    .order-guide button {
        justify-self: center;
    }

    .order-info {
        font-size: 12px;
        text-align: center;
        padding: 3px 10px;
        margin: auto;
    }

    .order-info.requested,
    .order-info.enter-cr {
        background-color: rgb(var(--v-theme-primary), 0.18);
        color: rgb(var(--v-theme-rich-blue));
    }

    .order-info.enter-cr a {
        font-weight: bold;
    }

    .order-info.ordered {
        background-color: rgb(var(--v-theme-green), 0.3);
        color: rgb(var(--v-theme-green-hover));
    }

    .powered-by-ossis {
        margin-left: -55px;
        margin-top: 5px;
    }

    .powered-by-ossis img {
        position: absolute;
        height: 30px;
        margin-top: -5px;
        margin-left: 5px;
    }
</style>